import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private toastController: ToastController
    ) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = '';

                if (error.status === 401) {
                    errorMessage = 'Sesión expirada. Por favor, vuelva a iniciar sesión.';
                    // Limpiar datos locales
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('selectedConsorcio');
                    this.router.navigate(['/login']);
                } else if (error.status === 0) {
                    if (!navigator.onLine) {
                        errorMessage = 'Sin conexión a internet. Verifique su red.';
                    } else {
                        errorMessage = 'No se pudo conectar con el servidor. Intente más tarde.';
                    }
                } else {
                    errorMessage = `Error: ${error.message}`;
                }

                if (errorMessage) {
                    this.presentToast(errorMessage);
                }

                return throwError(() => error);
            })
        );
    }

    async presentToast(message: string) {
        const toast = await this.toastController.create({
            message: message,
            duration: 3000,
            position: 'bottom',
            color: 'danger'
        });
        toast.present();
    }
}
